import { Link } from '@tanstack/react-router';
import Logo from '../ui/Logo.jsx';
import Icon from '../ui/Icon.jsx';
import Avatar from '../ui/Avatar.jsx';

const NAV = [
  { path: '/dashboard', label: 'Dashboard', icon: 'dashboardGrid' },
  { path: '/research-profiles/new', label: 'Build New Report', icon: 'sparkles' },
  { path: '/research-profiles', label: 'View My Reports', icon: 'report', exact: true },
  { path: '/profiles', label: 'HNWI Database', icon: 'search' },
  { path: '/people', label: 'New Wealth', icon: 'database' },
  { path: '/events', label: 'Wealth Signals', icon: 'pulse' },
  { path: '/parties', label: 'Liquidity Events', icon: 'circleDollar' },
  { path: '/sources', label: 'Archetypes', icon: 'archetype' },
];

export default function Sidebar({ user, onSignOut, collapsed, onToggle }) {
  const displayName = user?.email || 'Account';

  return (
    <aside className={`sidebar${collapsed ? ' is-collapsed' : ''}`}>
      <div className="sidebar-brand">
        <Logo size={32} />
        {!collapsed && <span className="sidebar-wordmark">Diligencify</span>}
        <button
          type="button"
          className="sidebar-toggle"
          onClick={onToggle}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <Icon name={collapsed ? 'chevronRight' : 'chevronLeft'} size={16} />
        </button>
      </div>

      <nav className="sidebar-nav">
        {NAV.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            activeOptions={{ exact: item.exact }}
            className="nav-item"
            activeProps={{ className: 'nav-item is-active' }}
            title={collapsed ? item.label : undefined}
          >
            <Icon name={item.icon} size={18} />
            {!collapsed && <span>{item.label}</span>}
          </Link>
        ))}
      </nav>

      <div className="sidebar-bottom">
        <Link
          to="/settings"
          className="nav-item"
          activeProps={{ className: 'nav-item is-active' }}
          title={collapsed ? 'Settings' : undefined}
        >
          <Icon name="target" size={18} />
          {!collapsed && <span>Settings</span>}
        </Link>

        <div className="sidebar-user">
          <Avatar name={displayName} size={32} />
          {!collapsed && (
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="user-name" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {displayName}
              </div>
            </div>
          )}
          {!collapsed && (
            <button
              type="button"
              onClick={onSignOut}
              aria-label="Sign out"
              title="Sign out"
              style={{
                background: 'transparent',
                border: 0,
                cursor: 'pointer',
                color: 'var(--fg-subtle)',
                display: 'flex',
                alignItems: 'center',
                padding: 4,
                borderRadius: 6,
                flexShrink: 0,
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = 'var(--fg)'}
              onMouseLeave={(e) => e.currentTarget.style.color = 'var(--fg-subtle)'}
            >
              <Icon name="logOut" size={16} />
            </button>
          )}
        </div>
      </div>
    </aside>
  );
}
